import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleVisibility } from 'store/conciergeSlice';
import { useIsConfigConstantEqual } from 'hooks/useConfigConstant';
import IconHandler from 'components/common/icon/IconHandler';
import { useLocation } from 'react-router-dom';
import { useHasConciergeDomains } from 'app/concierge/hooks/useHasConciergeDomains';
import useBundleTranslation from 'i18n';

export default function MenuConcierge() {
    const { t } = useBundleTranslation(['app/concierge/widget']);
    const dispatch = useDispatch();
    const isEnabledConciergeIcon = useIsConfigConstantEqual('ENABLE_CONCIERGE_ICON', true);
    const isEnabledConcierge = useIsConfigConstantEqual('ENABLE_CONCIERGE', true);

    const conciergeSettings = useSelector((state: any) => state.auth?.configuration?.conciergeSettings) ?? {};
    const conciergeSettingDisplay = conciergeSettings.display ?? 'topbar';
    const conciergePanelVisible = useSelector((state: any) => state.concierge.visible);
    const location = useLocation();
    const isPortalPage = location.pathname.includes('/p/');

    const { hasDomains } = useHasConciergeDomains();

    const onClick = () => {
        dispatch(toggleVisibility());
    };

    const iconProps = {
        type: conciergeSettings.bot_icon_ind,
        value:
            conciergeSettings.bot_icon_ind === 'upload'
                ? `data:image/png;base64,${conciergeSettings.bot_icon_data}`
                : conciergeSettings.bot_icon_name,
    };

    if (
        !(
            conciergeSettingDisplay === 'topbar' &&
            isEnabledConciergeIcon &&
            isEnabledConcierge &&
            !conciergePanelVisible &&
            !isPortalPage
        )
    ) {
        return null;
    }

    return (
        <>
            <Box className={'navbar-menu__root-item-component-icon'}>
                <Tooltip title={hasDomains ? '' : t('no_sources')} placement="bottom">
                    <span>
                        <IconButton
                            onClick={hasDomains ? onClick : undefined}
                            sx={!hasDomains ? { opacity: 0.38, cursor: 'default', '&:hover': { backgroundColor: 'transparent' } } : {}}
                        >
                            <IconHandler icon={iconProps} sx={{ fontSize: '16px' }} />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>
            <Box className={'navbar-menu__item-divider'} />
        </>
    );
}
